import { useSelector } from 'react-redux';
import {
  selectFilterData,
  selectFilterCriteriaData,
  selectSingleAssembleData,
  selectCreationFormData
} from 'pages/LooseItems/AssembledBOM/selectors';

export function useAssembledBOMSelector() {
  const filter = useSelector(selectFilterData());
  const filterCriteria = useSelector(selectFilterCriteriaData());

  const currentAssembly = useSelector(selectSingleAssembleData());

  const creationForm = useSelector(selectCreationFormData());

  return {
    filter,
    filterCriteria,
    currentAssembly,
    creationForm
  };
}
